import React, { useEffect, useState } from 'react';
import LKModal from '../../../Modal/Modal';
import './StoreAvailability.scss';
import { checkStoreAvailability } from '../../../../../actionCreators/product';
import { useDispatch, useSelector } from 'react-redux';
import gpsIcon from './../../../../../../static/assets/svg/gps.svg';
import availableStockOnly from './../../../../../../static/assets/svg/od-black-checkbox.svg';
import StoreAvailabilityStatuses from './StoreAvailabilityStatuses/StoreAvailabilityStatuses';
import ButtonOwnDays from '../../../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import { v4 } from 'uuid';
import StoreAvailabilityStatus from './StoreAvailabilityStatuses/StoreAvailabilityStatus/StoreAvailabilityStatus';
import useModalScrollLock from '../../../../../own-days/hooks/useModalScrollLock';

const StoreAvailability = ({ storeAvailability, setStoreAvailability, isMobile }) => {
  const stores = useSelector(state => state.product?.storeAvailability);
  const productData = useSelector(state => state.product?.productData?.result);

  const dispatch = useDispatch();
  const [showAvailableStockOnly, setShowAvailableStockOnly] = useState(false);

  useModalScrollLock(storeAvailability);

  useEffect(() => {
    if (storeAvailability && productData) {
      if (window?.location?.href?.includes('preproduction')) {
        dispatch(checkStoreAvailability('AR2001-T', '03', 303189, 0, 20));
      } else {
        dispatch(checkStoreAvailability(productData?.modelName, '03', productData?.id, 0, 20));
      }
    }
  }, [dispatch, productData, storeAvailability]);

  const handleshowAvailableStockOnly = () => {
    setShowAvailableStockOnly(!showAvailableStockOnly);
  };

  const close = () => {
    setStoreAvailability(false);
  };

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = event => {
    setSearchTerm(event.target.value);
  };

  const filteredStores =
    stores &&
    stores.filter(store => {
      const isStockAvailable = showAvailableStockOnly
        ? store.status === 'In Stock' || store.status === 'Running Low'
        : true;
      const matchesSearchTerm = store.storeName.toLowerCase().includes(searchTerm.toLowerCase());
      return isStockAvailable && matchesSearchTerm;
    });

  const [touchStartY, setTouchStartY] = useState(null);

  const handleTouchStart = e => {
    setTouchStartY(e.touches[0].clientY);
  };

  const handleTouchMove = e => {
    if (touchStartY !== null) {
      const deltaY = e.touches[0].clientY - touchStartY;
      if (deltaY > 100) {
        setStoreAvailability(false);
        setTouchStartY(null);
      }
    }
  };

  const handleTouchEnd = () => {
    setTouchStartY(null);
  };

  return (
    storeAvailability && (
      <>
        {isMobile ? (
          <div
            className="store-availability-modal store-availability-modal-m"
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
            onTouchStart={handleTouchStart}
          >
            <div className="store-availability">
              <div className="swipe-indicator">&nbsp;</div>
              <div className="store-availability__header">
                <div className="store-availability__header__title od-font-bold">
                  Product availability in stores
                </div>
                <div className="store-availability__header__message od-font-reg">
                  This product is available in the stores listed below.
                </div>
              </div>
              <div className="store-availability__search-container">
                <input
                  className="store-availability__search-input od-font-reg"
                  placeholder="Search area/store/city to filter"
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <img alt="gps" src={gpsIcon} />
              </div>
              <div className="store-availability__checkbox" onClick={handleshowAvailableStockOnly}>
                {!showAvailableStockOnly ? (
                  <div className="od-checkbox" />
                ) : (
                  <img alt="available stock only" src={availableStockOnly} />
                )}

                <div className="store-availability__checkbox__title od-font-reg">
                  Show stores with available stock only
                </div>
              </div>
              <StoreAvailabilityStatuses />
              <div className="store-availability__content">
                <div className="store-availability__store-item stores-title">
                  <div className="store-availability__store-name">Shop</div>
                  <div className="store-availability__store-availability">Availability</div>
                </div>
                {stores && stores.length > 0 ? (
                  <div className="store-availability__store-list-scroll">
                    <ul className="store-availability__store-list od-font-reg">
                      {filteredStores.map(store => {
                        const status =
                          store?.status === 'In Stock'
                            ? 'inStock'
                            : store?.status === 'Running Low'
                            ? 'stockLow'
                            : 'outOfStock';

                        return (
                          <li key={v4()} className="store-availability__store-item">
                            <div className="store-availability__store-name">{store?.storeName}</div>
                            {store.status && <StoreAvailabilityStatus status={status} />}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  <div className="store-availability__no-stores od-font-bold">
                    No stores available
                  </div>
                )}
                <div className="store-availability__find-store-wrapper">
                  <ButtonOwnDays
                    fontClass="store-availability__find-store od-font-bold"
                    mode="oval-grey"
                    text="Find Stores"
                    onClick={() => {
                      if (window?.location?.href?.includes('preproduction')) {
                        window.location.href = 'https://preproduction.owndays.com/stores/sg';
                      } else {
                        window.location.href = 'https://www.owndays.com/stores/sg';
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <LKModal
            backdrop
            keyboard
            dialogClassName="store-availability-modal"
            hideHandler={close}
            outSideContentClick={close}
            showModal={storeAvailability}
          >
            <div className="store-availability">
              <div className="store-availability__header">
                <div className="store-availability__header__title od-font-bold">
                  Product availability in stores
                </div>
                <div className="store-availability__header__message od-font-reg">
                  This product is available in the stores listed below.
                </div>
              </div>
              <div className="store-availability__search-container">
                <input
                  className="store-availability__search-input od-font-reg"
                  placeholder="Search area/store/city to filter"
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <img alt="gps" src={gpsIcon} />
              </div>
              <div className="store-availability__checkbox" onClick={handleshowAvailableStockOnly}>
                {!showAvailableStockOnly ? (
                  <div className="od-checkbox" />
                ) : (
                  <img alt="available stock only" src={availableStockOnly} />
                )}
                <div className="store-availability__checkbox__title od-font-reg">
                  Show stores with available stock only
                </div>
              </div>
              <StoreAvailabilityStatuses />
              <div className="store-availability__content">
                <div className="store-availability__store-item stores-title">
                  <div className="store-availability__store-name">Shop</div>
                  <div className="store-availability__store-availability">Availability</div>
                </div>
                {stores && stores.length > 0 ? (
                  <ul className="store-availability__store-list od-font-reg">
                    {filteredStores.map(store => {
                      const status =
                        store?.status === 'In Stock'
                          ? 'inStock'
                          : store?.status === 'Running Low'
                          ? 'stockLow'
                          : 'outOfStock';

                      return (
                        <li key={v4()} className="store-availability__store-item">
                          <div className="store-availability__store-name">{store?.storeName}</div>
                          {store.status && <StoreAvailabilityStatus status={status} />}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className="store-availability__no-stores od-font-bold">
                    No stores available
                  </div>
                )}
                <div className="store-availability__find-store-wrapper">
                  <ButtonOwnDays
                    fontClass="store-availability__find-store od-font-bold"
                    mode="oval-grey"
                    text="Find Stores"
                    onClick={() => {
                      if (window?.location?.href?.includes('preproduction')) {
                        window.location.href = 'https://preproduction.owndays.com/stores/sg';
                      } else {
                        window.location.href = 'https://www.owndays.com/stores/sg';
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </LKModal>
        )}
      </>
    )
  );
};

export default StoreAvailability;
